import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Location } from 'history';
import { getDistributorById, updateDistributorRM } from '../../redux-store/actions/userManagement';
import {
  AdddistributorRM,
  DistributorNewList,
  SubDistributorListType,
} from '../../redux-store/types/api-types';
import { ColumnType } from '../DataTable';
import { subdistributorTypes } from '../../utils/constant';
import UserMgmtListPage, {
  NameLinkCell,
  buildAccessColumn,
  buildActionsColumn,
  formatUserName,
  matchesUserSearch,
} from './UserMgmtListPage';

function DistributorRm({
  location,
}: {
  location: Location<{ distributorId: string }>;
}): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const { distributorId } = location.state || {};

  return (
    <UserMgmtListPage<SubDistributorListType>
      loadDeps={[distributorId]}
      loadData={async () => {
        if (!distributorId) {
          history.replace('/user-management');
          return [];
        }
        const res = (await dispatch(getDistributorById(distributorId))) as unknown as DistributorNewList;
        return res?.subdistributors || [];
      }}
      searchPlaceholder="Search for Distributor's RM"
      inviteLabel="Add Distributor's RM"
      onInvite={() => history.push('add-distributors-rm', { distributorId })}
      filterRow={(row, q) =>
        matchesUserSearch(q, [
          formatUserName(row.user),
          row.user?.email,
          row.distributors_RM_Code,
          row.panNumber,
          row.rm?.name,
          subdistributorTypes[row.subdistributorType],
        ])
      }
      getColumns={({ onToggleAccess }) => {
        const columns: ColumnType[] = [
          {
            header: `Distributor's RM name`,
            align: 'left',
            headerAlign: 'left',
            renderCell: (row: SubDistributorListType) => (
              <NameLinkCell
                label={formatUserName(row.user)}
                to={{ pathname: 'distributors-rm-details', state: { subDistributorId: row.id } }}
              />
            ),
          },
          {
            header: `Distributor's RM code`,
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: SubDistributorListType) => row.distributors_RM_Code || 'N/A',
          },
          {
            header: 'Distributor RM Type',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: SubDistributorListType) =>
              subdistributorTypes[row.subdistributorType] || 'N/A',
          },
          {
            header: 'Email Id',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: SubDistributorListType) => row.user?.email || 'N/A',
          },
          {
            header: 'PAN',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: SubDistributorListType) => row.panNumber || 'N/A',
          },
          {
            header: `AMC's RM`,
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: SubDistributorListType) => row.rm?.name || 'N/A',
          },
          buildAccessColumn(onToggleAccess),
          buildActionsColumn((row: SubDistributorListType) => [
            {
              label: 'View Details',
              icon: '/images/view-application.svg',
              to: { pathname: 'distributors-rm-details', state: { subDistributorId: row.id } },
            },
            {
              label: 'Edit Details',
              icon: '/images/edit.svg',
              to: { pathname: 'edit-distributors-rm', state: { subDistributorId: row.id } },
            },
          ]),
        ];
        return columns;
      }}
      onAccessChange={async (row, nextActive) =>
        (await dispatch(
          updateDistributorRM(row.id as number, {
            ...(row as unknown as AdddistributorRM),
            isActive: nextActive,
          })
        )) as unknown as SubDistributorListType
      }
    />
  );
}

export default DistributorRm;
